import React from 'react';
import Styled from 'styled';
import { Link, LinkProps } from 'react-router-dom';

import defaultStyles from './cover-button.scss';
import SVGIcon from 'lib/images/svg-icon/svg-icon';


interface IBaseProps {
    styles: typeof defaultStyles;
    label: any;
    to?: string;
}

interface IconBaseProps extends IBaseProps {
    icon: React.ReactElement<any>;
    iconSrc?: string;
}

interface IconSrcBaseProps extends IBaseProps {
    icon?: React.ReactElement<any>;
    iconSrc: string;
}

type BaseProps = IconBaseProps | IconSrcBaseProps;

interface ButtonProps extends Partial<React.ButtonHTMLAttributes<HTMLButtonElement>> {
    tag: 'button';
}

interface InputProps extends Partial<React.HTMLAttributes<HTMLSpanElement>> {
    tag: 'span';
}

interface RouterLinkProps extends Partial<LinkProps> {
    tag: React.ComponentType<LinkProps>;
}

interface AnchorProps extends Partial<React.HTMLAttributes<HTMLAnchorElement>> {
    tag: 'a';
}

export type Props =
    | (BaseProps & ButtonProps)
    | (BaseProps & InputProps)
    | (BaseProps & AnchorProps)
    | (BaseProps & RouterLinkProps);

export default Styled(defaultStyles)(({ styles, icon, iconSrc, label, tag, children, ...rest }: Props) => (
    <div className={styles.button}>
        {React.createElement(
            tag,
            { ...rest, className: styles.tag } as any,
            <span className={styles.wrapper}>
                {icon || <SVGIcon style={{image: styles.icon}} src={iconSrc} />}
                <span className={styles.label}>{label}</span>
                {children}
            </span>
        )}
        <span className={styles.buttonLabel}>{label}</span>
    </div>
));
